module.exports = __webpack_public_path__ + "static/img/about052.8f0f401.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about052.png
// module id = hka6
// module chunks = 1